import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { TabConst } from 'src/app/tabms/tab-consts';

@Component({
  selector: 'app-base-password-input',
  templateUrl: './base-password-input.component.html',
  styleUrl: './base-password-input.component.scss'
})
export class BasePasswordInputComponent {

  @Input() control: FormControlName
  @Input() size: 'default' | 'compact' | 'xs' = TabConst.DEFAULTSIZE // New input for size control
  hide = true;
  newHide = true;
  // conHide = true;

}

